import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite, RoughEase, Linear, Ease, Power3} from "gsap";
import {SpacierArcadeGameConfig} from "../../SpacierArcadeGameConfig";
import {SpacierArcadeWildSymbol} from "../../symbols/SpacierArcadeWildSymbol";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import { DisplayObject } from "pixi.js";
import {SAHelper} from "../../utils/SAHelper";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomBounce.js");

export interface IShakeConfig{
    x:number;
    y:number;
    obj:DisplayObject;
    duration:number;
    Intensity?:number;
    hertz:number;
    ease?:Ease | CustomEase;
    reverseEase?:boolean;
    positionCb?:() => PIXI.Point;
}

export class SAMultiplierAddupView extends BaseView{
    private _layer:ScalableLayer;
    private _tempStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 60,
        fontWeight : FontWeight.BOLD,
        align : "center",
        dropShadow : true,
        dropShadowAlpha : 0.6,
        dropShadowAngle : 89.5,
        dropShadowBlur : 6,
        dropShadowColor : "#1a1740",
        dropShadowDistance : 3,
        fill : [
            "#fff7e8",
            "#fffdec",
            "#fff0aa",
            "#ffc733"
        ],
        miterLimit : 7,
        stroke : "#bd1e96",
        strokeThickness : 1
    };


    constructor() {
        super();
        this._layer = StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
    }

    public animateMultipliers(overlayWildsMultipliers:number[][]):TimelineLite{
        let animTimeLine:TimelineLite = new TimelineLite();
        for (let i:number = 0; i < overlayWildsMultipliers.length; i++){
            for(let j:number = 0; j < overlayWildsMultipliers[i].length; j++) {
                if(overlayWildsMultipliers[i][j] > 0) {
                    let atl:TimelineLite = new TimelineLite();
                    let oldsymbol:SpacierArcadeWildSymbol = <SpacierArcadeWildSymbol>Reels.getSymbol(i, j);
                    atl.add([oldsymbol.changeState({
                        state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.winMulti
                    }), TweenLite.fromTo(StageManager.stage, 0.5, {x:-2}, {x:2, ease:new RoughEase({strength:3, points:20, template:Linear.easeNone, randomize:false}) , clearProps:"x"})]);
                    atl.add(SAHelper.Shake({
                        x: .2,
                        y: 1,
                        duration: 0.5 + (2 * 0.2),
                        hertz: 180 + (2 * 60),
                        Intensity: 8 + (2 * 6.5),
                        obj: StageManager.stage,
                        positionCb: () => new PIXI.Point(0,0),
                        ease: Power3.easeOut,
                        reverseEase: true
                    }), atl.totalDuration() - 0.4);
                    animTimeLine.add(atl, 0);
                }
            }
        }
        return animTimeLine;
    }
}